enum DisplayNames {
  Table = 'Table',
  TableBody = 'TableBody',
  TableCaption = 'TableCaption',
  TableCell = 'TableCell',
  TableColumnCell = 'TableColumnCell',
  TableContainer = 'TableContainer',
  TableFooter = 'TableFooter',
  TableHeader = 'TableHeader',
  TableRow = 'TableRow'
}

export default DisplayNames;
